import React, { ButtonHTMLAttributes } from "react";
import { BasicColor, ColorProps, StatusColor } from "../../types";
import { useButtonProps } from "./hooks";
import { ButtonShape, ButtonSize, ButtonVisibility } from "./_types";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  ColorProps<BasicColor | StatusColor> &
  ButtonSize &
  ButtonShape &
  ButtonVisibility & {
    close?: boolean;
    disabled?: boolean;
    icon?: React.ReactElement;
    loading?: boolean;
    text?: string;
  };

export const Button = (props: ButtonProps) => {
  const { children, icon, text, ...rest } = useButtonProps(props);
  return (
    <button {...rest}>
      {icon}
      {children}
      {text && <span className="ml-2">{text}</span>}
    </button>
  );
};

export default Button;
